import { getAuthenticatedResponse } from "@/lib/http-client";

/** Download a file (CSV, XLSX, ZIP) from an authenticated export endpoint. */
export async function downloadAuthenticatedFile(
  path: string,
  params?: object,
  filename = "export",
): Promise<void> {
  const response = await getAuthenticatedResponse(path, params);

  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`);
  }

  const blob = await response.blob();
  const disposition = response.headers.get("content-disposition");
  const match = disposition?.match(/filename="?([^"]+)"?/i);
  const resolvedName = match?.[1] ?? filename;

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = resolvedName;
  anchor.click();
  URL.revokeObjectURL(url);
}
